import HttpClient from "../client/httpclient";
import {readMore} from "../read-more";
import 'regenerator-runtime/runtime';
class RoomCard {
    constructor(DOMelement, openButtonsDOMlist) {
      try {
        this.el = DOMelement;
        this.openButtons = openButtonsDOMlist;
        this.method = "GET";
        this.counter = 1;
        this.URL = '../src/components/room-card/room-card.html?p=';
        this.loadMoreButton = document.getElementById("property__rooms-button");
        
        if(this.loadMoreButton) {
          this.URL = this.loadMoreButton.getAttribute("data-action");
          this.totalpage = this.loadMoreButton.getAttribute("data-totalpages");
        }

        if (process.env.NODE_ENV === "development") {
          this.URL = '../src/components/room-card/room-card.html?p=';
        }

        [...openButtonsDOMlist].forEach((button) =>
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.loadMoreRooms();
        })
      );
      } catch (error) {
        console.log(error);
      }        
    }

    stringToHTML(str) {             
      const support = (function () {
        if (!window.DOMParser) return false;
        var parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html');
        } catch(err) {
            return false;
        }
        return true;
      })();
      
      if (support) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(str, 'text/html');
          return doc.body;
      }
  
      var dom = document.createElement('div');
      dom.innerHTML = requestedCard.responseText;
      return dom;        
    };

    async loadMoreRooms () {   
      if(this.counter < this.totalpage) {
        const url = `${this.URL}&page=${this.counter}`;
        var button = document.querySelector('.property__rooms-button');
        await HttpClient.AsyncGetRequest(url, this.method)
        .then(card => {
          var room = this.stringToHTML(card);
          for (var i = 0; i < room.childNodes.length; i++) {
            button.insertAdjacentElement("beforebegin", room.childNodes[i]);
            readMore.init();
          const observer = lozad();
          observer.observe();
          }     
          if(this.counter == this.totalpage - 1) {      
            this.loadMoreButton.style.display = "none";
          }     
        }).catch(error => {
          console.error(error)
        });
      }
      this.counter = this.counter + 1; 
      };      
    }
export default RoomCard